const profileActionTypes = {

    START_GET_PROFILE_BY_GROUP_ID: 'START_GET_PROFILE_BY_GROUP_ID',
    GET_PROFILES_BY_GROUP_ID_SUCCESS: 'GET_PROFILES_BY_GROUP_ID_SUCCESS',
    GET_PROFILES_BY_GROUP_ID_FAILURE: 'GET_PROFILES_BY_GROUP_ID_FAILURE',

    START_ADD_PROFILE: 'START_ADD_PROFILE',
    ADD_PROFILE_SUCCESS: 'ADD_PROFILE_SUCCESS',
    ADD_PROFILE_FAILURE: 'ADD_PROFILE_FAILURE',

    START_UPDATE_PROFILE: 'START_UPDATE_PROFILE',
    UPDATE_PROFILE_SUCCESS: 'UPDATE_PROFILE_SUCCESS',
    UPDATE_PROFILE_FAILURE: 'UPDATE_PROFILE_FAILURE',

    START_ACTIVATE_PROFILE: 'START_ACTIVATE_PROFILE',
    ACTIVATE_PROFILE_SUCCESS: 'ACTIVATE_PROFILE_SUCCESS',
    ACTIVATE_PROFILE_FAILURE: 'ACTIVATE_PROFILE_FAILURE',

    START_DELETE_PROFILE: 'START_DELETE_PROFILE',
    DELETE_PROFILE_SUCCESS: 'DELETE_PROFILE_SUCCESS',
    DELETE_PROFILE_FAILURE: 'DELETE_PROFILE_FAILURE',

    SELECT_PROFILE: 'SELECT_PROFILE',
    UNSELECT_PROFILE: 'UNSELECT_PROFILE',
    UPDATE_TRANSACTION_DATA: 'UPDATE_TRANSACTION_DATA',
    RESET: 'RESET',

    RESET_STATE_INFO: 'RESET_STATE_INFO',
};

export default profileActionTypes;